import React, { Fragment, useState } from 'react'
import { Tabs , Tab } from 'react-bootstrap'
import { filter } from 'lodash'

import { CoverageFilters, CoverageTable } from "./Coverage"
import { DetailsFilters, DetailsTable } from "./Details"
import { coverageFilteredData } from './Data'

const SPLAScopeReport = ({ customerAssets = [], filterOptions = {} }) => {
  const [coverageFilters, changeCoverageFilters] = useState({
    locations: 'All', functions: 'All', licenseReportTypes: 'All',
    powerState: 'All', customers: 'All',
  })
  const [detailsFilters, changeDetailsFilters] = useState({})
  const assetsWithAutomatedReporting = filter(customerAssets, ['automated_spla_reporting', true])

  return (
    <Fragment>
      <Tabs defaultActiveKey="coverage" className="mb-3">
        <Tab eventKey="coverage" title="Coverage">
          <CoverageFilters {...{ filters: coverageFilters, changeFilters: changeCoverageFilters, filterOptions }} />

          <CoverageTable {...{ assets: coverageFilteredData({ customerAssets, filters: coverageFilters }) }}/>
        </Tab>

        <Tab eventKey="details" title="Details">
          <DetailsFilters {...{ filters: detailsFilters, changeFilters: changeDetailsFilters, filterOptions }} />

          <DetailsTable {...{ assets: assetsWithAutomatedReporting }} />
        </Tab>
      </Tabs>
    </Fragment>
  )
}

export default SPLAScopeReport
